module.exports = __webpack_public_path__ + "static/DeceitCoverSliderImage-1d60e8cddeee109938bc735c9174c0ea.jpeg";